import Icon from "../../utils/Icon"
import { useEffect, useReducer } from "react"
import DataExportReducer, { initialDataExportsData } from "./reducers/data_export_reducer"
import { get_data_exports } from "./api"
import { setState } from "../../utils/CommonReducer"
import TableHeads from "../../visualizers/tabular/TableHeads"
import TableRows from "../../visualizers/tabular/TableRows"
import Pagination from "../../../Pagination"
import { LoaderComponent } from "../../utils/LoaderComponent"
import Tooltip from "../../cta_utils/Tooltip"
import ExportAppliedTags from "./export_applied_tags"
import ConditionalRender from "../../../ConditionalRender"

const DATA_EXPORT_MAPPER = {
    'inprogress': {
        label: 'Processing',
        color: 'yellow',
        reason: ''
    },
    'delayed': {
        label: 'Delayed',
        color: 'orange',
        reason: 'Reason: Processing delay due to high data volume. Please wait. '
    },
    'failed': {
        label: 'Failed',
        color: 'red',
        reason: 'This issue has been reported to our team. We’ll get back to you soon.'
    },
    'completed': {
        label: 'Completed',
        color: 'green',
        reason: ''
    },
}
export const DATA_EXPORT_NAME = {
    'LinkedinProspect': 'Datamine list export'
}
const DataExports = () => {
    const [pageData, pageDataReducer] = useReducer(DataExportReducer, initialDataExportsData)   
    const {totalPages, currentPage, data, isFetching} = pageData
    useEffect(() => {
        fetchData(1);
    }, [])
    const fetchData = (page) => {
        let data_params = {page: page}
        setState(pageDataReducer)({isFetching: {loadingPageData: true}})
        get_data_exports(data_params).then((res) => {
            let payload = {
                data: res.data.data,
                totalPages: res.data.total_pages,
                totalCount: res.data.total,
                currentPage: page,
                isFetching: {loadingPageData: false},
            }
            setState(pageDataReducer)(payload)
        }).catch((error) => {
            setState(pageDataReducer)({isFetching: {loadingPageData: false}})
        })
    }
    const handleOnClosePopup = () => setState(pageDataReducer)({popupList: {}, currentExport: {}})
    const renderTableContent = () => (
        <div>
        <table className="data_table" style={{textAlign: "left"}}>
            <TableHeads typoGraphyClass="text_body_big_light" headerClass="table_header_row">
                <th style={{width: "35%"}}>Name</th>
                <th style={{width: "20%", whiteSpace: 'nowrap'}}>Date & Time</th>
                <th style={{width: "10%"}}>
                    <div className="default_flex_container">
                        Status
                        <Tooltip
                            tooltipText={() => "Report generation might take\nanywhere between 2 min - 45\nmin depending on the data\nvolume. You can download here\nwhen report is ready."}
                            innerClass='text_body_light'
                            textTheme='background-light-black top'
                            innerStyle={{ padding: '8px', textAlign: 'center', color: 'white', borderRadius: '8px' }}
                            showWithoutOverflowing={true}
                            tooltipPos="top"
                        >
                            <div style={{ width: 16, height: 16, marginLeft: 4 }}>
                                <Icon name="Info" style={{ verticalAlign: 'unset', width: '100%', height: '100%' }} />
                            </div>
                        </Tooltip>
                    </div>
                </th>
                <th style={{width: "10%"}}>Progress</th>
                <th style={{width: "30%"}}>Action</th>
            </TableHeads>
            <tbody>
                {
                   data?.map(data_export => (
                        <TableRows key={data_export.id} rowClass="table_content_row text_body">
                            <td style={{wordBreak: 'break-word'}}>{DATA_EXPORT_NAME[data_export.type] || data_export.name} 
                                <ConditionalRender if={data_export.type === 'LinkedinProspect' && data_export.tags?.length > 0}>
                                    <div className="text_link" onClick={()=>setState(pageDataReducer)({popupList: {exportTagsPopup: true}, currentExport: data_export})}>More Info</div> 
                                </ConditionalRender>
                            </td>
                            <td>{data_export.created_time}</td>
                            <td><div className={`label_container ${DATA_EXPORT_MAPPER[data_export.state]?.color}`}>{DATA_EXPORT_MAPPER[data_export.state]?.label}</div></td>
                            <td>{data_export.progress + "%"}</td>
                            <td>{data_export.download_url ? 
                            <a href={data_export.download_url} className="text_link hover_under_line">Download<Icon name="Download" style={{width: 20, height: 20, verticalAlign: 'bottom', marginLeft: 2}}/></a>
                            : DATA_EXPORT_MAPPER[data_export.state]?.reason}</td>
                        </TableRows>
                    ))
                }
                <ConditionalRender if={data?.length === 0}>
                    <TableRows rowClass="table_content_row text_body" customStyles={{ textAlign: 'center'}}>
                    <td colSpan="5">
                        <div style={{margin: '88px auto 135px', textAlign: 'center'}}>
                        <Icon name="NoExport" style={{marginBottom: 4}}/>
                        <div className="text_body_big_light_bold">No exports have been requested yet.</div>
                        </div>
                    </td>
                    </TableRows>
                </ConditionalRender>
            </tbody>
        </table>
        </div>
    )
    return (
        <div>
            <div className="bs-content" style={{maxWidth: 800, margin: '32px auto', padding: '24px 0px'}}>
                <div className="bs-content-padding">
                    <div className="text_title_big">Data Exports</div>
                    <div className="default_flex_container">
                        <Icon name="Info"/>
                        <div className="text_subtitle_semi_bold" style={{marginLeft: 4}}>Export up to 5 files at a time. Please wait for an ongoing export to finish before starting a new one.</div>
                    </div>
                </div>
                <div  className="line_seperator_ex_light_grey" style={{ margin: "16px auto" }}></div> 
                <div className="bs-content-padding">
                    <div>
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={fetchData}
                        />
                    </div>
                </div>
                <div className="bs-content-padding" style={{paddingTop: 8}}>
                    {
                        !isFetching.loadingPageData ? 
                            renderTableContent() :
                            (<LoaderComponent isLoading={true}  loaderStyle={{width: 32, margin: '36px auto', display: 'block'}}/>)

                    }
                </div>
            </div>
            {pageData.popupList.exportTagsPopup && <ExportAppliedTags data_export={pageData.currentExport} handleOnClosePopup={ handleOnClosePopup}/>}
        </div>
    )
}
export default DataExports